import { render, staticRenderFns } from "./Comment2.vue?vue&type=template&id=2cf6b7cd&scoped=true"
import script from "./Comment2.vue?vue&type=script&lang=js"
export * from "./Comment2.vue?vue&type=script&lang=js"
import style0 from "./Comment2.vue?vue&type=style&index=0&id=2cf6b7cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6b7cd",
  null
  
)

export default component.exports